import React, { useState } from 'react';
import { createPortal } from 'react-dom';

import { HintTarget, HintBubble } from '../../styled-comps';

// Hover tooltip that survives table-cell overflow clipping: the bubble is
// portaled to document.body and positioned (fixed) under the hovered target.
const HoverHint = ({ hint, children }) => {
  const [pos, setPos] = useState(null);

  const show = event => {
    const rect = event.currentTarget.getBoundingClientRect();
    setPos({ left: rect.left, top: rect.bottom + 6 });
  };
  const hide = () => setPos(null);

  return (
    <>
      <HintTarget onMouseEnter={show} onMouseLeave={hide}>
        {children}
      </HintTarget>
      {pos &&
        createPortal(
          <HintBubble $left={pos.left} $top={pos.top}>{hint}</HintBubble>,
          document.body,
        )}
    </>
  );
};

export default HoverHint;
